<template>
  <v-dialog v-model="dialogEditShow" max-width="420px">
    <v-card class="pa-4 pa-sm-8">
      <v-btn class="button-close ma-4" icon @click="dialogEditShow=false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <h4 class="mb-5">Вес вопроса в блоке</h4>
      <v-text-field label="Вес" outlined dense v-model="localValue" :error-messages="checkFloat(localValue)" />
      <div class="row mt-4 justify-end">
        <v-btn class="mr-3 _w-100" @click="dialogEditShow=false"> Отмена </v-btn>
        <v-btn class="_w-100" color="primary" @click="askSave"> Сохранить </v-btn>
      </div>
    </v-card>
    <AskDialog
      v-model="showAskSaveDialog"
      title="Изменение веса"
      text="Изменить вес вопроса в блоке?"
      textOk="Сохранить"
      @ok="save"
    />
  </v-dialog>
</template>

<script>
/* eslint-disable */
import AskDialog from '@/components/ui/AskDialog';
import { checkFloat, toFloat } from '@/common/util';

export default {
  components: {
    AskDialog,
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: Boolean,
    weight: [Number, String],
  },
  data: () => ({
    localValue: 1.0,
    showAskSaveDialog: false,
  }),
  watch: {
    dialogEditShow(newVal) {
      if (newVal) {
        this.localValue = this.weight ?? 1.0;
      }
    }
  },
  computed: {
    dialogEditShow: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', false);
      }
    },
  },
  methods: {
    askSave() {
      if (typeof checkFloat(this.localValue) === 'string') return;
      this.showAskSaveDialog = true
    },
    save() {
      this.$emit('save', toFloat(this.localValue));
      this.dialogEditShow = false
    },
    checkFloat,
  }
};
</script>
